import { render, staticRenderFns } from "./UnidadMedida.vue?vue&type=template&id=6cb809ec"
import script from "./UnidadMedida.vue?vue&type=script&lang=ts"
export * from "./UnidadMedida.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports